"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssetTypeText = AssetTypeText;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const types_1 = require("@src/types");
const icons_1 = require("@ant-design/icons");
const react_intl_1 = require("react-intl");
const AssetTypeTextContainer = styled_components_1.default.div `
	display: flex;
	align-items: center;
	gap: 0.25rem;
`;
function AssetTypeText({ assetType }) {
    const intl = (0, react_intl_1.useIntl)();
    const assetTypeTitle = {
        [types_1.AssetType.DOCUMENT]: intl.formatMessage({ id: 'assets.types.document' }),
        [types_1.AssetType.IMAGE]: intl.formatMessage({ id: 'assets.types.image' }),
        [types_1.AssetType.VIDEO]: intl.formatMessage({ id: 'assets.types.video' }),
    }[assetType];
    const AssetTypeIcon = {
        [types_1.AssetType.DOCUMENT]: icons_1.FileTextOutlined,
        [types_1.AssetType.IMAGE]: icons_1.FileImageOutlined,
        [types_1.AssetType.VIDEO]: icons_1.PlayCircleOutlined,
    }[assetType];
    return ((0, jsx_runtime_1.jsxs)(AssetTypeTextContainer, { children: [(0, jsx_runtime_1.jsx)(AssetTypeIcon, {}), assetTypeTitle] }));
}
